import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get light list
export const getFSLightList = async (fs_feature_id: number) => {
    try {
        const response = await apiClient.get(`/api/fs-light-list/${fs_feature_id}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// add light locations
export const addFSLightLocation = async (
    fs_feature_id: number,
    location_id_list: number[],
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/fs-light-location/add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ fs_feature_id, location_id_list }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// delete light location
export const deleteFSLightLocation = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(
            `${baseURL}/api/fs-light-location/delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// create Light
export const fsLightCreate = async (
    fs_data_id: number,
    item_id: number,
    type_id: number,
    number: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("item_id", String(item_id));
        formData.append("type_id", String(type_id));
        formData.append("number", String(number));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-light/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update Light
export const fsLightUpdate = async (
    id: number,
    item_id: number,
    type_id: number,
    number: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("item_id", String(item_id));
        formData.append("type_id", String(type_id));
        formData.append("number", String(number));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-light/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Delete Light
export const fsLightDelete = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(
            `${baseURL}/api/fs-light/delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
